import { DATA_TYPE } from './insightsTypes';
import { CombinedProps, FilterOption } from './saveData.types';

export const processData = (
  data: Record<string, string | number>[],
  dataType: DATA_TYPE,
  groupedBy?: { label: string; value: string }[],
) => {
  switch (dataType) {
    case DATA_TYPE.STATE_OF_REPORTS:
      return processStateOfReports(data);
    case DATA_TYPE.INTAKE_PER_CATEGORY:
      return processIntakePerCategory(data);
    case DATA_TYPE.REPORT_STATUS_CATEGORY:
      return processReportStatusCategory(data);
    case DATA_TYPE.DEPARTMENTS_ACROSS_LOCATIONS:
      return processDepartmentsAcrossLocations(data, groupedBy);
    case DATA_TYPE.CATEGORIES_PER_DEPARTMENT:
      return processCategoriesPerDepartment(data);
  }
};

const processStateOfReports = (data: Record<string, string | number>[]) => {
  return data.map((row) => ({
    Status: row.group_name,
    Percentage: row.letter_label,
  }));
};

const processIntakePerCategory = (data: Record<string, string | number>[]) => {
  return data.map((row) => ({
    Intake: row.type,
    Count: row.count,
    Category: row.group_name,
  }));
};

const processReportStatusCategory = (
  data: Record<string, string | number>[],
) => {
  return data.map((row, index) => ({
    'Report number': index + 1,
    Country: row.country,
    New: row.new,
    Read: row.read,
    Investigating: row.investigating,
    Closed: row.closed,
    Total: row.total,
  }));
};

const processDepartmentsAcrossLocations = (
  data: Record<string, string | number>[],
  groupedBy: { label: string; value: string }[] = [
    { label: 'Country', value: 'COUNTRY' },
  ],
) => {
  const location = groupedBy?.[0].label.toLowerCase();
  const capitalizedLocation = location[0].toUpperCase() + location.substring(1);
  return data.map((row) => ({
    [capitalizedLocation]: row.country,
    Department: row.department,
    Reports: row.reports,
  }));
};

const processCategoriesPerDepartment = (
  data: Record<string, string | number>[],
) => {
  return data.map((row) => ({
    Category: row.type,
    Department: row.group_name,
    Count: row.count,
  }));
};

export const processFiltersForAuditLog = (
  filters: CombinedProps['filters'],
) => {
  const groupByFilter =
    filters?.selectionFilter?.filter(
      (filter: { type: string }) => filter.type === 'CLUSTER',
    ) ?? [];
  const nonGroupByFilters =
    filters?.selectionFilter?.filter(
      (filter: { type: string }) => filter.type !== 'CLUSTER',
    ) ?? [];
  return {
    ...(filters && 'normaliseFilter' in filters
      ? { normalised: filters.normaliseFilter?.normalised }
      : {}),
    ...(filters && 'timeFilter' in filters
      ? { timeFilter: filters.timeFilter?.timeframeInput }
      : {}),
    selectionFilters: nonGroupByFilters.map(
      (filter: {
        label: FilterOption['label'];
        options: FilterOption[];
        value: { label: FilterOption['label'] }[];
        type: 'SINGLE' | 'MULTI' | 'CLUSTER' | 'TIME';
      }) => ({
        label: filter.label,
        allSelected: filter.options.length === (filter.value?.length ?? 0),
        selectedValues: filter.value.map(({ label }) => label) ?? [],
        type: filter.type,
      }),
    ),
    ...(groupByFilter.length
      ? { groupedBy: groupByFilter[0].value?.[0].label }
      : {}),
  };
};
